<template>
  <div style="height:100%">
    <el-row class="title-bar mr-t10" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4">예외 이벤트 이력</div>
      </div>
      <div class="vertical-center-box">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="table" border header-align="center" :data="tableData" :total="total" :columns="tableColumns"
    :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true" :fit-height="true" @condition-change="loadData" remote
    style="height: calc(100vh - 502px);border-bottom: 1px solid #EBEEF5;" >
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{scope.row.eventMessage}}</span>
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import WEventlevelCell from '@/components/table/EventlevelCell';
import EventHistAPI from '@/api/event/event-hist';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WRootCauseEventTable',
  components: {
    WEventlevelCell,
  },
  props: {
    eventHistData: {
      type: Object,
      default: () => {},
    },
    nodeData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    rootObjId() {
      if (!isNil(this.eventHistData)) {
        return this.eventHistData.objId;
      }
      return 0;
    },
    rootEventSeqNumber() {
      if (!isNil(this.eventHistData)) {
        return this.eventHistData.seqNumber;
      }
      return 0;
    },
  },
  data() {
    return {
      showSearchTool: false,
      isLoading: false,
      total: 0,
      tableData: [],
      tableColumns: [
        {
          prop: 'eventlevelName',
          label: '등급',
          width: 80,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevel',
          remoteProp: 'eventlevelId',
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 110,
          headerAlign: 'center',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'objName',
          label: '대상',
          width: 110,
          headerAlign: 'center',
          formatter: this.getTargetInfo,
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 100,
          headerAlign: 'center',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          searchable: true,
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          width: 130,
          headerAlign: 'center',
          // searchType: 'date',
          // searchable: true,
          formatter: this.getDateFormatter,
        },
      ],
    };
  },
  watch: {
    nodeData: {
      handler(value) {
        if (!isEmpty(value)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        rootEventSeqNumber: this.rootEventSeqNumber,
        rootObjId: this.rootObjId,
      };
      if (!isEmpty(this.nodeData.objIds)) {
        params.objIds = this.nodeData.objIds;
      }
      EventHistAPI.getRootCauseEventExceptList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.tableData = result.data;
          this.total = result.total;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getTargetInfo(row, column, value) {
      if (row.objDefineId !== 'SERVICE' && row.objDefineId !== 'E2E_SERVICE' && row.objDefineId !== 'FMS_SENSOR') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      return getValueAfterCheckEmpty(value);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/popup/RootCauseAnalysisPopup/components/RootCauseEventTable.vue